const Terms = () => {
  const termsData = {
    title: "TERMS OF USE",
    lastUpdated: "Last updated January 04, 2026",
    company: {
      name: "Biggest Fans",
      address:
        "28 marcos drive, Birmingham, West Midlands B38 9ND, United Kingdom",
      email: "razzleturner09@icloud.com",
      altEmail: "biggestfans00@gmail.com",
    },
    intro: {
      description: "Biggest Fan points, Wheel spins.",
      agreement: `These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you"), and Biggest Fans, concerning your access to and use of the Services.`,
      warning:
        "IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.",
      minors:
        "All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the Services.",
    },
    sections: [
      {
        number: "1",
        heading: "OUR SERVICES",
        content:
          "The information provided when using the Services is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation. Those persons who choose to access the Services from other locations do so on their own initiative and are solely responsible for compliance with local laws.",
      },
      {
        number: "2",
        heading: "INTELLECTUAL PROPERTY RIGHTS",
        subsections: [
          {
            title: "Our intellectual property",
            text: 'We are the owner or the licensee of all intellectual property rights in our Services, including all source code, databases, functionality, software, designs, audio, video, text, photographs, and graphics (collectively, the "Content"), as well as the trademarks, service marks, and logos (the "Marks").',
          },
          {
            title: "Your use of our Services",
            text: "Subject to your compliance with these Legal Terms, we grant you a non-exclusive, non-transferable, revocable license to:",
            bullets: [
              "Access the Services",
              "Download or print a copy of any portion of the Content to which you have properly gained access",
              "Solely for your personal, non-commercial use",
            ],
          },
          {
            title: "Your submissions",
            text: 'By directly sending us any question, comment, suggestion, idea, feedback, or other information about the Services ("Submissions"), you agree to assign to us all intellectual property rights in such Submissions.',
            bullets: [
              'You confirm that you have read and agree with our "PROHIBITED ACTIVITIES"',
              "You warrant that any such Submissions are original to you or that you have the necessary rights",
              "You warrant that your Submissions do not constitute confidential information",
              "You are solely responsible for your Submissions",
            ],
          },
        ],
      },
      {
        number: "3",
        heading: "USER REPRESENTATIONS",
        text: "By using the Services, you represent and warrant that:",
        bullets: [
          "All registration information you submit will be true, accurate, current, and complete",
          "You will maintain the accuracy of such information",
          "You have the legal capacity and agree to comply with these Legal Terms",
          "You are not a minor, or if a minor, you have received parental permission",
          "You will not access the Services through automated or non-human means",
          "You will not use the Services for any illegal or unauthorized purpose",
          "Your use of the Services will not violate any applicable law or regulation",
        ],
      },
      {
        number: "4",
        heading: "USER REGISTRATION",
        content:
          "You may be required to register to use the Services. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine it is inappropriate, obscene, or otherwise objectionable.",
      },
      {
        number: "5",
        heading: "PRODUCTS",
        content:
          "All products are subject to availability. We reserve the right to discontinue any products at any time for any reason. Prices for all products are subject to change.",
      },
      {
        number: "6",
        heading: "PURCHASES AND PAYMENT",
        text: "We accept the following forms of payment:",
        bullets: ["Mastercard", "Visa", "American Express", "PayPal"],
        additional:
          "You agree to provide current, complete, and accurate purchase and account information for all purchases. Sales tax will be added to the price of purchases as deemed required. All payments shall be in GBP.",
      },
      {
        number: "7",
        heading: "REFUNDS POLICY",
        content: "All sales are final, and no refund will be issued.",
        alert: true,
      },
      {
        number: "8",
        heading: "PROHIBITED ACTIVITIES",
        text: "You may not access or use the Services for any purpose other than that for which we make the Services available. As a user of the Services, you agree not to:",
        bullets: [
          "Systematically retrieve data or other content from the Services",
          "Trick, defraud, or mislead us and other users",
          "Circumvent, disable, or interfere with security-related features",
          "Disparage, tarnish, or otherwise harm us and/or the Services",
          "Use any information obtained from the Services to harass, abuse, or harm another person",
          "Make improper use of our support services",
          "Use the Services in a manner inconsistent with any applicable laws",
          "Engage in unauthorized framing of or linking to the Services",
          "Upload or transmit viruses, Trojan horses, or other harmful material",
          "Engage in any automated use of the system",
          "Delete the copyright or other proprietary rights notice",
          "Attempt to impersonate another user or person",
          "Interfere with, disrupt, or create an undue burden on the Services",
          "Harass, annoy, intimidate, or threaten our employees or agents",
          "Attempt to bypass any measures designed to prevent or restrict access",
          "Copy or adapt the Services' software",
          "Decipher, decompile, disassemble, or reverse engineer any software",
          "Use automated systems including spiders, robots, or scrapers",
          "Use a buying agent or purchasing agent to make purchases",
          "Make any unauthorized use of the Services",
          "Use the Services for any revenue-generating endeavor or commercial enterprise",
        ],
      },
      {
        number: "9",
        heading: "USER GENERATED CONTRIBUTIONS",
        content: "The Services does not offer users to submit or post content.",
      },
      {
        number: "10",
        heading: "CONTRIBUTION LICENCE",
        content:
          "You and Services agree that we may access, store, process, and use any information and personal data that you provide following the terms of the Privacy Policy. By submitting suggestions or other feedback regarding the Services, you agree that we can use and share such feedback for any purpose without compensation to you.",
      },
      {
        number: "11",
        heading: "MOBILE APPLICATION LICENCE",
        subsections: [
          {
            title: "Use Licence",
            text: "If you access the Services via the App, we grant you a revocable, non-exclusive, non-transferable, limited right to install and use the App. You shall not:",
            bullets: [
              "Decompile, reverse engineer, disassemble, or decrypt the App",
              "Make any modification, adaptation, or derivative work from the App",
              "Violate any applicable laws in connection with your access or use",
              "Remove, alter, or obscure any proprietary notice",
              "Use the App for any revenue-generating endeavor",
              "Make the App available over a network for multiple users",
              "Use the App for creating a competitive product or service",
              "Use the App to send automated queries or unsolicited commercial email",
              "Use any proprietary information in the design of any applications",
            ],
          },
          {
            title: "Apple and Android Devices",
            text: "The following terms apply when you use the App obtained from either the Apple Store or Google Play:",
            bullets: [
              "The licence is limited to a non-transferable licence for use on Apple iOS or Android devices",
              "We are responsible for providing maintenance and support services",
              "You may notify the App Distributor of any warranty failures",
              "You represent you are not in a US Government embargoed country",
              "You must comply with applicable third-party terms of agreement",
              "App Distributors are third-party beneficiaries of these terms",
            ],
          },
        ],
      },
      {
        number: "12",
        heading: "ADVERTISERS",
        content:
          "We allow advertisers to display their advertisements and other information in certain areas of the Services. We simply provide the space to place such advertisements, and we have no other relationship with advertisers.",
      },
      {
        number: "13",
        heading: "SERVICES MANAGEMENT",
        text: "We reserve the right, but not the obligation, to:",
        bullets: [
          "Monitor the Services for violations of these Legal Terms",
          "Take appropriate legal action against anyone who violates the law or these Legal Terms",
          "Refuse, restrict access to, limit the availability of, or disable any of your Contributions",
          "Remove from the Services files and content that are excessive in size",
          "Otherwise manage the Services in a manner designed to protect our rights and property",
        ],
      },
      {
        number: "14",
        heading: "PRIVACY POLICY",
        content:
          "We care about data privacy and security. Please review our Privacy Policy: biggestfansoftheworld.com. By using the Services, you agree to be bound by our Privacy Policy. Please be advised the Services are hosted in the United Kingdom.",
      },
      {
        number: "15",
        heading: "TERM AND TERMINATION",
        content:
          "These Legal Terms shall remain in full force and effect while you use the Services. WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES TO ANY PERSON FOR ANY REASON. We may terminate your use or participation in the Services or delete your account at any time, without warning.",
      },
      {
        number: "16",
        heading: "MODIFICATIONS AND INTERRUPTIONS",
        content:
          "We reserve the right to change, modify, or remove the contents of the Services at any time for any reason at our sole discretion without notice. We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance.",
      },
      {
        number: "17",
        heading: "GOVERNING LAW",
        content:
          "These Legal Terms shall be governed by and defined following the laws of the United Kingdom. Biggest Fans and yourself irrevocably consent that the courts shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these Legal Terms.",
      },
      {
        number: "18",
        heading: "DISPUTE RESOLUTION",
        subsections: [
          {
            title: "Informal Negotiations",
            text: "The Parties agree to first attempt to negotiate any Dispute informally for at least ninety (90) days before initiating arbitration.",
          },
          {
            title: "Binding Arbitration",
            text: "Any dispute shall be determined by one arbitrator chosen in accordance with the Arbitration and Internal Rules of the European Court of Arbitration. The seat of arbitration shall be Birmingham, United Kingdom. The language of the proceedings shall be English.",
          },
          {
            title: "Restrictions",
            text: "The Parties agree that:",
            bullets: [
              "No arbitration shall be joined with any other proceeding",
              "There is no right for any Dispute to be arbitrated on a class-action basis",
              "There is no right for any Dispute to be brought in a representative capacity",
            ],
          },
          {
            title: "Exceptions to Informal Negotiations and Arbitration",
            bullets: [
              "Any Dispute seeking to enforce or protect intellectual property rights",
              "Any Dispute related to allegations of theft, piracy, invasion of privacy",
              "Any claim for injunctive relief",
            ],
          },
        ],
      },
      {
        number: "19",
        heading: "CORRECTIONS",
        content:
          "There may be information on the Services that contains typographical errors, inaccuracies, or omissions. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information at any time, without prior notice.",
      },
      {
        number: "20",
        heading: "DISCLAIMER",
        content:
          'THE SERVICES ARE PROVIDED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES. WE MAKE NO WARRANTIES ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES\' CONTENT.',
      },
      {
        number: "21",
        heading: "LIMITATIONS OF LIABILITY",
        content:
          "IN NO EVENT WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, ARISING FROM YOUR USE OF THE SERVICES. OUR LIABILITY TO YOU WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US.",
      },
      {
        number: "22",
        heading: "INDEMNIFICATION",
        text: "You agree to defend, indemnify, and hold us harmless from and against any loss, damage, liability, claim, or demand made by any third party due to or arising out of:",
        bullets: [
          "Use of the Services",
          "Breach of these Legal Terms",
          "Any breach of your representations and warranties",
          "Your violation of the rights of a third party",
          "Any harmful act toward any other user of the Services",
        ],
      },
      {
        number: "23",
        heading: "USER DATA",
        content:
          "We will maintain certain data that you transmit to the Services for managing performance. Although we perform regular routine backups, you are solely responsible for all data that you transmit. We shall have no liability for any loss or corruption of any such data.",
      },
      {
        number: "24",
        heading: "ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES",
        content:
          "Visiting the Services, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS.",
      },
      {
        number: "25",
        heading: "CALIFORNIA USERS AND RESIDENTS",
        content:
          "If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.",
      },
      {
        number: "26",
        heading: "MISCELLANEOUS",
        content:
          "These Legal Terms constitute the entire agreement between you and us. Our failure to exercise any right shall not operate as a waiver. We may assign any or all of our rights and obligations to others at any time. If any provision is determined to be unlawful, that provision is deemed severable and does not affect the remaining provisions.",
      },
      {
        number: "27",
        heading: "NO REFUNDS",
        content: "No refunds no matter what.",
        alert: true,
      },
    ],
  };

  return (
    <section className="relative pt-48 pb-24 z-0 bg-gradient-to-b from-gray-900 to-black">
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl mx-auto px-4">
        <div className="space-y-12">
          {/* Header */}
          <div className="text-center space-y-4 border-b border-white/10 pb-8">
            <h1 className="text-5xl font-bold text-white tracking-tight">
              {termsData.title}
            </h1>
            <p className="text-white/60 text-sm font-medium">
              {termsData.lastUpdated}
            </p>
          </div>

          {/* Company Info */}
          <div className="bg-white/5 rounded-lg p-6 border border-white/10">
            <h2 className="text-xl font-bold text-white mb-4">
              AGREEMENT TO OUR LEGAL TERMS
            </h2>
            <div className="space-y-3 text-white/80">
              <p>
                We are{" "}
                <strong className="text-white">{termsData.company.name}</strong>{" "}
                ("Company," "we," "us," or "our"), a company registered in the
                United Kingdom at{" "}
                <strong className="text-white">
                  {termsData.company.address}
                </strong>
              </p>
              <p>
                We operate the mobile application{" "}
                <strong className="text-white">Biggest Fans</strong> (the
                "App"), as well as any other related products and services that
                refer or link to these legal terms (collectively, the
                "Services").
              </p>
              <p className="font-semibold text-white">
                {termsData.intro.description}
              </p>
              <p>
                You can contact us by email at{" "}
                <a
                  href={`mailto:${termsData.company.email}`}
                  className="text-blue-400 hover:text-blue-300 underline"
                >
                  {termsData.company.email}
                </a>{" "}
                or by mail to {termsData.company.address}.
              </p>
            </div>
          </div>

          {/* Important Notice */}
          <div className="bg-red-500/10 border-2 border-red-500 rounded-lg p-6">
            <p className="text-white font-bold text-lg mb-2">
              {termsData.intro.agreement}
            </p>
            <p className="text-red-400 font-bold text-base">
              {termsData.intro.warning}
            </p>
          </div>

          {/* Minor Notice */}
          <div className="bg-yellow-500/10 border border-yellow-500/50 rounded-lg p-4">
            <p className="text-yellow-200 text-sm">
              <strong className="text-yellow-400">For Minors:</strong>{" "}
              {termsData.intro.minors}
            </p>
          </div>

          {/* Table of Contents */}
          <div className="bg-white/5 rounded-lg p-6 border border-white/10">
            <h2 className="text-2xl font-bold text-white mb-6">
              TABLE OF CONTENTS
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {termsData.sections.map((section) => (
                <a
                  key={section.number}
                  href={`#section-${section.number}`}
                  className="text-blue-400 hover:text-blue-300 transition-colors text-sm"
                >
                  {section.number}. {section.heading}
                </a>
              ))}
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {termsData.sections.map((section) => (
              <div
                key={section.number}
                id={`section-${section.number}`}
                className={`${
                  section.alert
                    ? "bg-red-500/10 border-2 border-red-500"
                    : "bg-white/5 border border-white/10"
                } rounded-lg p-6`}
              >
                <h3 className="text-2xl font-bold text-white mb-4">
                  {section.number}. {section.heading}
                </h3>

                {section.content && (
                  <p
                    className={`${
                      section.alert
                        ? "text-red-400 font-bold text-lg"
                        : "text-white/80"
                    } leading-relaxed`}
                  >
                    {section.content}
                  </p>
                )}

                {section.text && (
                  <p className="text-white/80 leading-relaxed mb-4">
                    {section.text}
                  </p>
                )}

                {section.bullets && (
                  <ul className="list-disc list-inside space-y-2 ml-4 text-white/80">
                    {section.bullets.map((bullet, idx) => (
                      <li key={idx} className="leading-relaxed">
                        {bullet}
                      </li>
                    ))}
                  </ul>
                )}

                {section.additional && (
                  <p className="text-white/80 leading-relaxed mt-4">
                    {section.additional}
                  </p>
                )}

                {section.subsections && (
                  <div className="space-y-6 mt-4">
                    {section.subsections.map((subsection, idx) => (
                      <div
                        key={idx}
                        className="pl-4 border-l-2 border-white/20"
                      >
                        <h4 className="text-lg font-bold text-white mb-3">
                          {subsection.title}
                        </h4>
                        {subsection.text && (
                          <p className="text-white/80 leading-relaxed mb-3">
                            {subsection.text}
                          </p>
                        )}
                        {subsection.bullets && (
                          <ul className="list-disc list-inside space-y-2 text-white/80">
                            {subsection.bullets.map((bullet, bidx) => (
                              <li key={bidx} className="leading-relaxed">
                                {bullet}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/30 rounded-lg p-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              28. CONTACT US
            </h2>
            <p className="text-white/80 mb-6">
              In order to resolve a complaint regarding the Services or to
              receive further information regarding use of the Services, please
              contact us at:
            </p>
            <div className="space-y-2 text-white">
              <p className="font-bold text-xl">{termsData.company.name}</p>
              <p className="text-white/80">{termsData.company.address}</p>
              <a
                href={`mailto:${termsData.company.email}`}
                className="text-blue-400 hover:text-blue-300 underline inline-block mt-2"
              >
                {termsData.company.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
